// extracted by mini-css-extract-plugin
module.exports = {"typeDetails":"_2-QOg"};